export function redirectToAuthPortal() {
	window.location.href = process.env.REACT_APP_AUTH_PORTAL as string;
}
